import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpen, CheckCircle, AlertCircle, Home, Clock, FileText, Utensils, Map, Mail, Sparkles, Heart, Plane, Baby, Moon, Users, ShoppingCart } from 'lucide-react';
const bonuses = [{
  name: 'The Panic Stop Checklist',
  description: 'Crisis management for today',
  value: 97,
  icon: AlertCircle
}, {
  name: 'Apartment Silence Blueprint',
  description: 'Soundproofing guide for complaints',
  value: 67,
  icon: Home
}, {
  name: 'The 48-Hour Rapid Calm Guide',
  description: 'Weekend desensitization technique',
  value: 47,
  icon: Clock
}, {
  name: 'The "Velcro Dog" Detachment Plan',
  description: 'Stop the bathroom following',
  value: 47,
  icon: Heart
}, {
  name: 'The Separation Tracker Sheet',
  description: 'Daily silence measurement log',
  value: 37,
  icon: FileText
}, {
  name: 'Anti-Anxiety Recipe Cookbook',
  description: '20 calming snack recipes',
  value: 37,
  icon: Utensils
}, {
  name: 'The "Safe-Home" Visual Map',
  description: 'Furniture arrangement for calm',
  value: 27,
  icon: Map
}, {
  name: 'The Neighbor Peace Letter Template',
  description: 'Communication script included',
  value: 27,
  icon: Mail
}, {
  name: 'Holiday & Fireworks Survival Guide',
  description: 'Extreme noise protocol',
  value: 27,
  icon: Sparkles
}, {
  name: 'The Rescue Dog Integration Guide',
  description: 'For adopted dogs with trauma',
  value: 27,
  icon: Heart
}, {
  name: 'Travel & Hotel Anxiety Manual',
  description: 'Calm in new places',
  value: 17,
  icon: Plane
}, {
  name: 'Puppy Independence 101',
  description: 'Prevent anxiety in puppies',
  value: 17,
  icon: Baby
}, {
  name: 'The Nighttime Panic Solution',
  description: 'Sleep without owner nearby',
  value: 17,
  icon: Moon
}, {
  name: 'The Walker & Sitter Instructions',
  description: 'Template for strangers',
  value: 17,
  icon: Users
}, {
  name: 'The Calm Dog Shopping List',
  description: 'Amazon/Chewy products that work',
  value: 17,
  icon: ShoppingCart
}];
export function OfferSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-white py-16 px-4" data-id="element-135">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-6xl mx-auto" data-id="element-136">
        <div className="text-center mb-12" data-id="element-137">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-138">
            Introducing:{' '}
            <span className="text-orange-500" data-id="element-139">
              The Paw-sitive Freedom Bundle
            </span>
          </h2>
          <p className="text-xl text-slate-700 mb-8" data-id="element-140">
            A complete digital system designed for the busy American dog owner
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/qyf85fyy6f9zFah9GnHsVU/pagina_principal.png" alt="The Paw-sitive Freedom Bundle - All guides and bonuses included" className="mx-auto max-w-sm md:max-w-md w-full rounded-xl mb-4" data-id="element-141" />
        </div>

        <div className="bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-300 rounded-2xl p-8 mb-12 shadow-xl" data-id="element-142">
          <div className="flex items-start gap-4 mb-4" data-id="element-143">
            <BookOpen className="w-12 h-12 text-orange-500 flex-shrink-0" data-id="element-144" />
            <div data-id="element-145">
              <h3 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2" data-id="element-146">
                The 15-Minute Calm Protocol
              </h3>
              <p className="text-lg text-slate-700 mb-2" data-id="element-147">
                Your step-by-step roadmap to a peaceful, independent dog
              </p>
              <p className="text-xl font-semibold text-orange-600" data-id="element-148">
                Value: $97
              </p>
            </div>
          </div>
        </div>

        <div className="mb-8" data-id="element-149">
          <h3 className="text-2xl md:text-3xl font-bold text-slate-900 text-center mb-8" data-id="element-150">
            Plus 15 Specialized Bonuses:
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-151">
            {bonuses.map((bonus, index) => {
            const Icon = bonus.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="bg-white border border-slate-200 rounded-lg p-5 hover:shadow-lg transition-shadow" data-id="element-152">
                  <div className="flex items-start gap-3 mb-3" data-id="element-153">
                    <Icon className="w-6 h-6 text-orange-500 flex-shrink-0 mt-1" data-id="element-154" />
                    <div className="flex-1" data-id="element-155">
                      <h4 className="font-semibold text-slate-900 mb-1" data-id="element-156">
                        {bonus.name}
                      </h4>
                      <p className="text-sm text-slate-600 mb-2" data-id="element-157">
                        {bonus.description}
                      </p>
                      <p className="text-sm font-semibold text-orange-600" data-id="element-158">
                        ${bonus.value} Value
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </motion.div>
    </section>;
}